<p-toast position="center"></p-toast>

<p-fileUpload name="myFiles[]" #fileUploadGeral accept=".xml,.xlsx,.pdf,.csv,.xls,.txt,.doc,image/*" [maxFileSize]="30000000" [multiple]="true"
    (uploadHandler)="uploadFiles(api, $event)" [showUploadButton]="showUploadButton" [customUpload]="true"
    (onSelect)="onSelect($event)" [showCancelButton]="false"
    chooseLabel="{{'upload_choose' | transloco }}" uploadLabel="{{'button_save' | transloco }}" cancelLabel="{{'upload_cancel' | transloco }}">
</p-fileUpload>